import { render } from "./ContentWrapper.vue?vue&type=template&id=655be444"
const script = {}

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__